module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-three-a.7e1bf43c.png";